import { render, staticRenderFns } from "./EditOrderModal.vue?vue&type=template&id=21bfc688&scoped=true&"
import script from "./EditOrderModal.vue?vue&type=script&lang=js&"
export * from "./EditOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfc688",
  null
  
)

export default component.exports